export var AddOrUpdateTrolleyRequestV2;
(function (AddOrUpdateTrolleyRequestV2) {
    AddOrUpdateTrolleyRequestV2.AddToBasketSourceEnum = {
        Aisle: 'Aisle',
        Department: 'Department',
        Shelf: 'Shelf',
        SearchProducts: 'SearchProducts',
        MultiSearch: 'MultiSearch',
        PastOrders: 'PastOrders',
        PastOrdersMaster: 'PastOrdersMaster',
        HaveYouForgottenPrevious: 'HaveYouForgottenPrevious',
        HaveYouForgottenImpulse: 'HaveYouForgottenImpulse',
        DynamicContent: 'DynamicContent',
        DcProductGroup: 'DcProductGroup',
        DcFavourites: 'DcFavourites',
        Deals: 'Deals',
        DealsDepartment: 'DealsDepartment',
        DealsAisle: 'DealsAisle',
        DealsShelf: 'DealsShelf',
        Favourites: 'Favourites',
        MySavedList: 'MySavedList',
        SavedListAllItems: 'SavedListAllItems',
        Recipe: 'Recipe',
        UsefulList: 'UsefulList',
        UsefulListAllItems: 'UsefulListAllItems',
        ExternalAddToTrolley: 'ExternalAddToTrolley',
        ProductDetails: 'ProductDetails',
        RelatedProducts: 'RelatedProducts',
        BonusProduct: 'BonusProduct',
        DeliveryPass: 'DeliveryPass',
        Trolley: 'Trolley',
        Unspecified: 'Unspecified',
        FavouritesAllItems: 'FavouritesAllItems',
        PastOrdersAllItems: 'PastOrdersAllItems',
        PastOrdersMasterAllItems: 'PastOrdersMasterAllItems',
        ChangePastOrder: 'ChangePastOrder'
    };
})(AddOrUpdateTrolleyRequestV2 || (AddOrUpdateTrolleyRequestV2 = {}));
